// extracted by mini-css-extract-plugin
module.exports = {"email":"aNTg","subHeadingText":"U0fk","verifyHeading":"-RCk","textColour":"-vep","linksContainer":"_9vak"};